<div *ngIf="getQuestionValue(question)">
  <div
    class="label uppercase text-xs"
    [class.text-secondary]="!isUnexpectedQuestion(question)"
    [class.text-warn]="isUnexpectedQuestion(question)"
  >
    {{ question.label }}
  </div>
  <div
    class="multiple-answers"
    *ngIf="
      !['table', 'input-file-upload', 'canvas', 'label'].includes(
        question.controlType
      )
    "
  >
    <mmx-copy-text class="value">{{
      getQuestionValue(question)
    }}</mmx-copy-text>
  </div>

  <div *ngIf="isImageQuestion(question) && getQuestionValue(question)">
    <img
      [src]="getQuestionValue(question)"
      [alt]="question.label"
      class="review-image"
    />
  </div>

  <div *ngIf="question.controlType === 'table'">
    <table class="mat-table mat-table--wide mat-table--small">
      <thead>
        <th class="mat-header-cell" *ngFor="let column of question.columns">
          {{ column | titlecase }}
        </th>
      </thead>
      <tbody>
        <tr
          class="multiple-answers"
          *ngFor="let row of getQuestionValue(question)"
        >
          <td *ngFor="let column of question.columns">{{ row[column] }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="ml-6" *ngIf="showIfQuestions(question)">
    <mmx-custom-question
      *ngFor="let childQuestion of question.ifQuestions"
      [question]="childQuestion"
      [intake]="intake"
    ></mmx-custom-question>
  </div>
</div>
